/**
 * Filter Panel Component
 * Provides filtering controls for job history tables
 */

import type { JobType, TenderLinkStatus, GeolocationStatus } from '@tender-monitor/shared/types/admin';

type FilterPanelProps = {
  jobType: JobType;
  status: string;
  startDate: string;
  endDate: string;
  onJobTypeChange: (type: JobType) => void;
  onStatusChange: (status: string) => void;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onReset: () => void;
};

const TENDER_LINK_STATUSES: { value: TenderLinkStatus | ''; label: string }[] = [
  { value: '', label: 'Wszystkie' },
  { value: 'pending', label: 'Oczekujące' },
  { value: 'processing', label: 'W trakcie' },
  { value: 'completed', label: 'Zakończone' },
  { value: 'failed', label: 'Błąd' },
  { value: 'skipped', label: 'Pominięte' },
];

const GEOLOCATION_STATUSES: { value: GeolocationStatus | ''; label: string }[] = [
  { value: '', label: 'Wszystkie' },
  { value: 'pending', label: 'Oczekujące' },
  { value: 'success', label: 'Sukces' },
  { value: 'failed', label: 'Błąd' },
  { value: 'not_found', label: 'Nie znaleziono' },
];

export function FilterPanel({
  jobType,
  status,
  startDate,
  endDate,
  onJobTypeChange,
  onStatusChange,
  onStartDateChange,
  onEndDateChange,
  onReset,
}: FilterPanelProps) {
  const statuses = jobType === 'tender-links' ? TENDER_LINK_STATUSES : GEOLOCATION_STATUSES;

  return (
    <div className="filter-panel">
      <div className="filter-group">
        <label htmlFor="jobType">Typ operacji</label>
        <select
          id="jobType"
          value={jobType}
          onChange={(e) => {
            onJobTypeChange(e.target.value as JobType);
            onStatusChange(''); // Reset status when changing job type
          }}
        >
          <option value="tender-links">Linki przetargów</option>
          <option value="parcels">Geolokalizacja działek</option>
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="status">Status</label>
        <select
          id="status"
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          {statuses.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="startDate">Od daty</label>
        <input
          id="startDate"
          type="date"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label htmlFor="endDate">Do daty</label>
        <input
          id="endDate"
          type="date"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </div>

      <div className="filter-group" style={{ alignSelf: 'flex-end' }}>
        <button className="admin-button" onClick={onReset}>
          Wyczyść filtry
        </button>
      </div>
    </div>
  );
}
